mutation ($teamId: ID!, $name: String!,  $iconId: ID,  $colorId: ID, $studentIds: [ID]) {
  group_create(
    teamId: $teamId,
    name: $name,
    iconId: $iconId,
    colorId: $colorId,
    studentIds: $studentIds
  ) {
    id
    name
  }
}
